import { useState } from "react";
import { Autocomplete, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useTesAutocompleteQuery from "../../../hooks/useTesAutocompleteQuery";
import { useAppSelector } from "../../../app/hooks";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import {
  DesktopDatePickerLight,
  RoundedButton,
} from "../../../common/components/styled/styled";
import { isValid } from "date-fns";

type Props = {
  fetchTesPriceList: (date: Date, tesId: string) => void;
};

export const BaseInfo = ({ fetchTesPriceList }: Props) => {
  const { t } = useTranslation();

  const { tes } = useAppSelector((state) => state.localized);
  const { setTesSearchTerm, tesIdsQueryResult } = useTesAutocompleteQuery();

  const [tesId, setTesId] = useState<string>("");
  const [validFrom, setValidFrom] = useState<Date | null>(null);

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:reviewDate")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <DesktopDatePickerLight
          format="dd.MM.yyyy"
          label={null}
          value={validFrom}
          onChange={(newValue: any) => {
            setValidFrom(newValue);
          }}
          slotProps={{ textField: { size: "small" } }}
        />
      </Grid>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:TES")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Autocomplete
          sx={{ maxWidth: "372px" }}
          value={tesId}
          options={tesIdsQueryResult}
          getOptionLabel={(tesId) => tesId && tes[tesId]}
          onInputChange={(event, newInput) => {
            if (event?.type === "change") {
              setTesSearchTerm(newInput);
            }
          }}
          onChange={(_, newValue) => setTesId(newValue ? newValue : "")}
          renderInput={(params) => <CommonTextField {...params} />}
        />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={9}>
        <RoundedButton
          disabled={!isValid(validFrom)}
          onClick={() => fetchTesPriceList(validFrom as Date, tesId)}
          variant="contained"
          sx={{ marginBottom: 3 }}
        >
          {t("search")}
        </RoundedButton>
      </Grid>
    </>
  );
};
